<script>
    // -- IMPORTS
    
	import EditManagerPage from './../../../../../ADMIN/src/lib/page/manager/EditManagerPage.svelte';
    import Modal from "../../../../../ADMIN/src/lib/component/element/Modal.svelte";
    import AdminEditButton from "../element/AdminEditButton.svelte";
    import ContactButtons from "../element/ContactButtons.svelte";
    import Media from "../element/Media.svelte";
    import { enabledAdminView } from "$src/lib/store/adminStore";
    import { languageTagStore } from "$src/lib/store/languageTagStore";
    import { fetchData, getProcessedMultilineTranslatedText } from "$src/lib/base";
    import { onMount } from 'svelte';
    import EditFoundersPage from '../../../../../ADMIN/src/lib/page/manager/EditFoundersPage.svelte';
    import { getLocalizedText, getLocalizedTextBySlug} from 'senselogic-gist';

    // -- VARIABLES

    /** @type {{id?: string, name?: string, imageSide?: string, mediaPath?: string, mediaPathArray?: any, position?: string, biography?: string, emailAddress?: string, linkedinLink?: string, instagramLink?: string, number?: number, type?: string, isFounder?: boolean}} */
    let {
        id = '',
        name = $bindable(''),
        imageSide = $bindable('right'),
        mediaPath = '',
        mediaPathArray = $bindable([]),
        position = $bindable(''),
        biography = $bindable(''),
        emailAddress = $bindable(''),
        linkedinLink = $bindable(''),
        instagramLink = $bindable(''),
        number = 0,
        type = $bindable(''),
        isFounder = false
    } = $props();

    let isEditManagerModalOpen = $state(false);
    let isBioExpanded = $state(false);
    let biographyElement = $state(null);
    let hasOverflow = $state(false);

    // -- FUNCTIONS

    onMount(
        () =>
        {
            if ( biographyElement )
            {
                setTimeout(
                    () =>
                    {
                        biographyElement.scrollHeight > biographyElement.clientHeight
                        ? hasOverflow = true
                        : hasOverflow = false
                    },
                    100
                    );
            }
        }
        );

    function handleOpenManagerModal(
        )
    {
        isEditManagerModalOpen = true;
    }

    function toggleBio() {
        isBioExpanded = !isBioExpanded;
    }
    // ~~

    function handleUpdateManager(
        )
    {
        isEditManagerModalOpen = false;
    }
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- CLASSES

    .manager-card
    {
        position: relative;
        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 2rem;
        align-items: flex-start;
        align-self: stretch;

        +media( desktop )
        {
            flex-direction: row;
            gap: 5rem;
        }
    }

    .manager-card.reverse
    {
        +media( desktop )
        {
            flex-direction: row-reverse;
        }
    }

    .manager-card-content
    {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        align-items: flex-start;
        align-self: stretch;

        +media( desktop )
        {
            width: 100%;

            flex: 1 0 0;
            gap: 2rem;
            justify-content: center;
        }
    }

    .manager-card-content-text
    {
        line-height: 2rem;
        font-size: 1.25rem;
        color: #BFC6CA;
    }

    .manager-card-heading-title
    {
        line-height: 3rem;
        font-size: 2rem;
        font-weight: 600;
        color: whiteColor;
    }

    .manager-card-image-container
    {
        height: auto;
        min-width: 100%;
        aspect-ratio: 1;

        object-fit: cover;
        object-position: center;

        +media( desktop )
        {
            position: sticky;
            top: 8rem;

            height: 30rem;
            min-width: auto;
        }
    }

    :global( .manager-card-image )
    {
        height: 100%;
        width: 100%;

        filter: grayscale( 100% );
    }

    .description-text
    {
        position: relative;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 10;
        overflow: hidden;

        transition: all .3s;
    }

    .description-text.is-expanded
    {
        -webkit-line-clamp: unset;
    }

    .read-more-button
    {
        background: none;
        border: 1px solid lightGoldColor;
        color: lightGoldColor;
        cursor: pointer;
        font-weight: bold;
        font-size: 1.25rem;
        align-self: flex-start;
        padding: 0.5rem 1rem;
    }
</style>

<Modal
    bind:showModal={ isEditManagerModalOpen }
    modalConfirmButtonLabel="Save"
    modalType=""
    hasFooterButtons={ false }
    modalTitle="Edit Manager"
>
    <EditManagerPage
        managerId={ id }
        onUpdateSucess={ handleUpdateManager }
    />
</Modal>

{#key [ name, imageSide, mediaPathArray, position, biography, emailAddress, linkedinLink, instagramLink, type ]}
    <div class="manager-card { imageSide === 'right' ? 'reverse' : '' }" class:is-admin-enabled={ $enabledAdminView }>
        <AdminEditButton
            handleAdminButton={ handleOpenManagerModal }
            title={ name }
            blockId={ id }
            blockMediaPath={ mediaPath || mediaPathArray }
            isManager={ true }
        />

        <div class="manager-card-image-container">
            <Media
                mediaId={ id }
                mediaClass="manager-card-image"
                mediaPath={ mediaPath || mediaPathArray }
                isGrayscale={ true }
            />
        </div>

        <div class="manager-card-content">
            <div>
                <p class="manager-card-heading-title">{ name }</p>
                <p class="manager-card-content-text">{@html getProcessedMultilineTranslatedText( position, $languageTagStore )}</p>
            </div>

            <div id={`biography-${ id }`} class="description-text" class:is-expanded={ isBioExpanded }  bind:this={ biographyElement }>
                {@html getProcessedMultilineTranslatedText( biography || '', $languageTagStore )}
            </div>
            {#if hasOverflow}
                <button class="read-more-button" onclick={ toggleBio }>
                    {@html
                        isBioExpanded
                        ? getLocalizedTextBySlug( 'read-less', $languageTagStore )
                        : getLocalizedTextBySlug( 'read-more', $languageTagStore )
                    }
                </button>
            {/if}

            <ContactButtons { emailAddress } { linkedinLink } { instagramLink } />
        </div>
    </div>
{/key}
